/* Copyright Airship and Contributors */
'use strict';
/**
 * Editor for tag groups.
 */
export class TagGroupEditor {
    /**
     * TagGroupEditor constructor
     *
     * @hidden
     * @param onApply The apply function
     */
    constructor(onApply) {
        this.onApply = onApply;
        this.operations = [];
    }
    /**
     * Adds tags to a tag group.
     *
     * @param tagGroup The tag group.
     * @param tags Tags to add.
     * @return The tag group editor instance.
     */
    addTags(group, tags) {
        const operation = { operationType: 'add', group: group, tags: tags };
        this.operations.push(operation);
        return this;
    }
    /**
     * Removes tags from the tag group.
     *
     * @param tagGroup The tag group.
     * @param tags Tags to remove.
     * @return The tag group editor instance.
     */
    removeTags(group, tags) {
        const operation = { operationType: 'remove', group: group, tags: tags };
        this.operations.push(operation);
        return this;
    }
    /**
     * Overwrite the current set of tags on the Tag Group.
     *
     * @param tagGroup The tag group.
     * @param tags Tags to set.
     * @return The tag group editor instance.
     */
    setTags(group, tags) {
        const operation = { operationType: 'set', group: group, tags: tags };
        this.operations.push(operation);
        return this;
    }
    /**
     * Applies the tag changes.
     */
    apply() {
        return this.onApply(this.operations);
    }
}
//# sourceMappingURL=TagGroupEditor.js.map